(function () {
  if (window.__magtionQ4Attribution) return;
  window.__magtionQ4Attribution = true;
  window.dataLayer = window.dataLayer || [];
  function push(name, params) { window.dataLayer.push(Object.assign({ event: name, season_state: 'halloween_2026' }, params || {})); }
  function promotionData(node) { return { promotion_id: node.dataset.promotionId || '', promotion_name: node.dataset.promotionName || '', creative_name: 'home_halloween_dark_section', location_id: 'homepage' }; }
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-q4-promotion]').forEach(function (node) { push('view_promotion', promotionData(node)); });
    document.querySelectorAll('header details, #menu-drawer details').forEach(function (node) {
      node.addEventListener('toggle', function () { if (node.open) push('nav_menu_open', { menu_name: (node.querySelector('summary') || {}).textContent || '', device_type: window.matchMedia('(max-width: 767px)').matches ? 'mobile' : 'desktop' }); });
    });
  });
  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href]');
    if (!link) return;
    var promo = link.closest('[data-q4-promotion]');
    if (promo) push('select_promotion', Object.assign(promotionData(promo), { link_url: link.pathname }));
    if (link.closest('header, #menu-drawer')) push('nav_click', { nav_level: link.closest('details') ? '2' : '1', link_label: link.textContent.trim(), destination_path: link.pathname, nav_location: link.closest('#menu-drawer') ? 'mobile_drawer' : 'header' });
  });
})();
